import { useMemo } from "react";
import { getNextBestDate } from "./getNextBestDate";


/**
 * Memoized hook to get the next best date from a list of dates,
 * relative to the current date and time zone.
 *
 * @param {object} event Event object
 * @param {array} dates Array of dates to pick from
 * @returns {moment} The next best date
 */
export function useNextBestDate(event, dates) {
    return useMemo(() => getNextBestDate(event, dates), [event, dates]);
}
